export function multiSelectOptionsObjectName(code: string) {
  return `${code}_options@internal`;
}
